import { createStore } from 'zustand'
import { createContext } from 'react'
import { PageInfo } from '@/components/molecules/pagination/Pagination'

export interface QueryParameters {
  query?: string
  pageInfo?: PageInfo
}

interface QueryParametersState extends QueryParameters {
  queryString: string
  updateQueryParams: (state: Partial<QueryParameters>) => void
  resetQueryParams: () => void
}

type QueryParametersStore = ReturnType<typeof createQueryParametersStore>

export const createQueryParametersStore = (qsp: URLSearchParams) => {
  const initialQuery = qsp.get('query') ?? undefined

  const defaultParams: QueryParameters = {
    query: initialQuery,
  }

  return createStore<QueryParametersState>()((set) => ({
    ...defaultParams,
    queryString: qsp.toString(),
    updateQueryParams: (newState) =>
      set(() => {
        if (newState.query) {
          qsp.set('query', newState.query)
        } else {
          qsp.delete('query')
        }
        return { ...newState, queryString: qsp.toString() }
      }),
    resetQueryParams: () =>
      set(() => {
        // Reset all page-related query parameters
        for (const param of Array.from(qsp.keys())) {
          if (param.includes('searchPage')) {
            qsp.delete(param)
          }
        }
        return { query: undefined, queryString: qsp.toString() }
      }),
  }))
}

export const QueryParametersStoreContext =
  createContext<QueryParametersStore | null>(null)
  
